import React from 'react';
import PropTypes from "prop-types";
import './Card.less';

const Card = (props) => {
    return (
        <div className={'Card' + (props.className == null ? '' : ' ' + props.className)}>
            {props.children}
        </div>
    );
}

Card.propTypes = {
    className: PropTypes.string,
};
Card.defaultProps = {}

export default Card;